import '../../../../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/globals';

(function($, window, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        let iso,
            cardOffset = 0,
            cardLimit = 5,
            loadMoreButton,
            newsList;

        if ($('.news-list-items').length) {
            newsList = $('.news-list-items');
            cardLimit = $(newsList).data('startcards');

            const getNewsCardListData = () => {
                $.ajax({
                    method: 'GET',
                    url: _AVENCY_BASE_actions.news.list,
                    data: {
                        offset: cardOffset,
                        limit: cardLimit,
                        identifier: $(newsList).data('identifier')
                    }
                }).done(function (data) {
                    const elements = $(data);
                    $(newsList).append(elements);
                    cardOffset = cardOffset + cardLimit;
                    cardLimit = $(newsList).data('showcards');

                    iso.appended(elements);

                    Array.from($(newsList).find('img')).forEach(picture => {
                        LazyLoad.load(picture);
                    });

                    if (!!data) {
                        loadMoreButton.removeClass('disabled');
                    } else {
                        loadMoreButton.addClass('disabled');
                    }
                });
            }

            iso = new window.Isotope('.news-list-items', {
                itemSelector: '.news-list-item',
                percentPosition: true,
                gutter: 10,
                masonry: {
                    columnWidth: '.grid-sizer'
                }
            });

            loadMoreButton = $('.news-list__show-more');

            loadMoreButton.on('click', function () {
                    getNewsCardListData();
            });

            getNewsCardListData();

            $('.filters-button-group button').on('click', function () {
                let filterValue = $(this).data('filter');

                iso.arrange({filter: filterValue});
            });

            $('.filters-button-group').on('click', 'button', function () {
                $(this).parent().find('button').removeClass('active');
                $(this).addClass('active');
            });
        }
    });
})(jQuery, window, window.PageLoadedQueue);
